import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function(){
	const slidingBlocksTop = document.querySelector('[data-block="sliding-blocks-top"]');
	const slidingBlocksBottom = document.querySelector('[data-block="sliding-blocks-bottom"]');

	if ( slidingBlocksTop || slidingBlocksBottom ) {
		// Match the height of the two containers.
		const topHeight = slidingBlocksTop ? slidingBlocksTop.offsetHeight : 0;
		const bottomHeight = slidingBlocksBottom ? slidingBlocksBottom.offsetHeight : 0;
		if ( topHeight > bottomHeight ) {
			gsap.set( slidingBlocksBottom, { height: topHeight } );
		} else {
			gsap.set( slidingBlocksTop, { height: bottomHeight } );
		}


		if ( window.innerWidth > 991 ) {
			if ( window.innerHeight < 780 ) {
				gsap.set( slidingBlocksTop, { xPercent: -70 } );
				gsap.set( slidingBlocksBottom, { xPercent: 80 } );
			} else {
				gsap.set( slidingBlocksTop, { xPercent: -80 } );
				gsap.set( slidingBlocksBottom, { xPercent: 80 } );
			}
			
			// Top
			const topTL = gsap.timeline({
				scrollTrigger: {
					trigger: slidingBlocksTop,
					start: 'top 50%',
					end: 'bottom 40%',
					scrub: 1.5,
					anticipatePin: 1,
					//markers: true,
				},
			});
	
			topTL.to( slidingBlocksTop, { xPercent: 0, duration: 1 } )
	
			// Bottom
			const bottomTL = gsap.timeline({
				scrollTrigger: {
					trigger: slidingBlocksBottom,
					start: window.innerHeight < 780 ? 'top 70%' : 'top 80%',
					end: 'bottom 70%',
					scrub: 1.5,
					anticipatePin: 1,
					//markers: true,
				},
			});
	
			bottomTL.to( slidingBlocksBottom, { xPercent: 0, duration: 1 } );	
		} else {
			const slidingBlocksBottom = document.querySelector('[data-block="sliding-blocks-bottom"]');
			
			if (slidingBlocksBottom && slidingBlocksBottom.parentElement.parentElement) {
				slidingBlocksBottom.parentElement.parentElement.scrollLeft += slidingBlocksBottom.parentElement.parentElement.scrollWidth;
			}
		}
	}
}